<template>
  <div class="oh text-left">
    <!--    <div>DEBUG model {{JSON.stringify(model, null, 2)}}</div>-->
<!--    <div>DEBUG grouped {{ JSON.stringify(grouped, null, 2) }}</div>-->
    <div v-if="textDisplay.length > 6" v-html="textDisplay"></div>
  </div>
</template>

<script>
import * as util from '../vendor/util'

export default {
  name: "oeffnungszeiten",
  props: ['openingHours'],
  data() {
    return {
      textDisplay: '',
      model: [],
      grouped: null,
    }
  },
  watch: {
    openingHours: {
      handler: function handler(newVal, oldVal) {
        if (newVal && newVal['1']) {
          this.init();
        }
      },
      deep: true,
    }
  },
  mounted() {
    this.init();
  },
  // activated() {
  //     this.init();
  // },
  methods: {
    init() {

      //init temp model which contains wd (weekday string) and text (Die Zeitspanne)
      try {
        let model = [];
        for (let day = 1; day < 8; day++) {
          let text = '';
          if (Object.keys(this.openingHours) < 7) {
            return 'Loading';
          }
          let oh = this.openingHours['' + day];
          if (oh.opened) {
            text +=
              util.displayOpeningHour(oh.a, 'from')
              + ' bis ' +
              util.displayOpeningHour(oh.a, 'till') + ' Uhr';

            let bhour = oh.b.fromHour;
            if (bhour !== -1) {
              text +=
                ' und ' +
                util.displayOpeningHour(oh.b, 'from')
                + ' bis ' +
                util.displayOpeningHour(oh.b, 'till') + ' Uhr';
            }
          } else {
            text += 'Geschlossen';
          }

          model.push({
            wd: util.weekday[day],
            text: text
          });
        }
        this.model = model;
        this.grouped = this.groupConsecutiveItemsByAttribute(model, 'text');

        //now add some table html for the output
        let result = '<table>';
        for (let row of this.grouped) {
          let firstWd = row[0].wd;
          let lastWd = row[row.length - 1].wd;
          let combined = firstWd;
          if (firstWd != lastWd) {
            combined = firstWd + ' bis ' + lastWd;
          }
          result += '<tr><td style="width:70px; white-space: nowrap">' + combined + ': </td>' +
            '<td>' + row[0].text + '</td></tr>';
        }
        result += '</table>';

        this.textDisplay = result;

      } catch (e) {
        console.log('Error init oeffnungszeiten: ' + e.message);
      }

      // console.log('textDisplay = ' + this.textDisplay);
    },

    groupConsecutiveItemsByAttribute(array, attribute) {
      const groupedItems = [];
      let currentGroup = [];

      array.forEach(item => {
        const itemName = item[attribute];

        if (currentGroup.length === 0 || currentGroup[0][attribute] === itemName) {
          currentGroup.push(item);
        } else {
          groupedItems.push(currentGroup);
          currentGroup = [item];
        }
      });

      if (currentGroup.length > 0) {
        groupedItems.push(currentGroup);
      }

      return groupedItems;
    },

    // init() {
    //     let result = '<table>';
    //     for (let day = 1; day < 8; day++) {
    //         let wd = util.weekday[day];
    //         result += '<tr><td>'+wd+': </td><td>';
    //
    //
    //         let oh = this.openingHours['' + day];
    //         if (oh.opened) {
    //             var hour = oh.a.fromHour;
    //             if (hour < 10) {
    //                 hour = '0' + oh.a.fromHour;
    //             }
    //             var minute = oh.a.fromMinute;
    //             if (minute < 10) {
    //                 minute = '0' + oh.a.fromMinute;
    //             }
    //             result +=
    //                 util.displayOpeningHour(oh.a, 'from')
    //                 + ' bis ' +
    //                 util.displayOpeningHour(oh.a, 'till') + ' Uhr';
    //
    //             var bhour = oh.b.fromHour;
    //             if (bhour !== -1) {
    //                 result +=
    //                     ' und ' +
    //                     util.displayOpeningHour(oh.b, 'from')
    //                     + ' bis ' +
    //                     util.displayOpeningHour(oh.b, 'till') + ' Uhr';
    //             }
    //         } else {
    //             result += 'Geschlossen';
    //         }
    //         result += '</td></tr>';
    //     }
    //     result += '</table>';
    //     this.display = result;
    // }

  }
}
</script>

<style lang="scss">
.oh {
  display: inline-block;

  table {
    td {
      text-align: left;
      vertical-align: top;

      &:first-child {
        padding-right: 0.5vw;
      }
    }
  }
}
</style>
